/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Devices_TitleInputs */

const en_why_listening_devices_title = /** @type {(inputs: Why_Listening_Devices_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen wherever you are`)
};

const es_why_listening_devices_title = /** @type {(inputs: Why_Listening_Devices_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha dondequiera que estés`)
};

/**
* | output |
* | --- |
* | "Listen wherever you are" |
*
* @param {Why_Listening_Devices_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_devices_title = /** @type {((inputs?: Why_Listening_Devices_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Devices_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_devices_title(inputs)
	return en_why_listening_devices_title(inputs)
});